// extracted by mini-css-extract-plugin
export var closeButton = "_ko-2";
export var closeButtonIcon = "_ko-3";
export var lightboxContent = "_ko-1";
export var lightboxOverlay = "_ko-0";